<div class="container">
  <div class="chart-container">
    <ngx-charts-line-chart
      *ngIf="!!config"
      [view]="config.view"
      [ngClass]="{ 'force-hover-state': forceHoverState }"
      [results]="config.seriesData"
      [legend]="config.showLegend"
      [xAxis]="config.showXAxis"
      [yAxis]="config.showYAxis"
      [customColors]="config.colorOverrides"
      [xAxisLabel]="config.xAxisLabel"
      [yAxisLabel]="config.yAxisLabel"
      [showXAxisLabel]="!!config.xAxisLabel"
      [showYAxisLabel]="!!config.yAxisLabel"
      [xAxisTickFormatting]="config.xAxisTickFormatting"
      [yAxisTickFormatting]="config.yAxisTickFormatting"
      [tooltipDisabled]="config.disableTooltip"
      [yScaleMin]="config.yAxisMin"
      [yScaleMax]="config.yAxisMax"
      [legendTitle]="'COMMON.LEGEND' | translate"
      [autoScale]="true"
    >
      <ng-template #seriesTooltipTemplate let-model="model">
        <div class="legend" *ngIf="!!model[0]?.value">
          <div class="legend--large">
            {{ formatDataPointDate(model[0]?.name, config.alignment) }}
          </div>
          <div class="legend--row" *ngFor="let mod of model; let i = index">
            <div class="legend--color" [ngStyle]="{ backgroundColor: mod.color }"></div>
            {{ mod.series }}: {{ config.yAxisTickFormatting(mod.value) }}
          </div>
        </div>
      </ng-template>
      <ng-template #tooltipTemplate let-model="model" class="legend">
        <div class="legend">
          <div class="legend--large">{{ config.yAxisTickFormatting(model.value) }}</div>
          <div>{{ formatDataPointDate(model.name, config.alignment) }}</div>
        </div>
      </ng-template>
    </ngx-charts-line-chart>
  </div>
  <div class="custom-legend">
    <ng-container *ngFor="let legendItem of legendConfig">
      <div class="legend-option">
        <mat-icon [ngStyle]="{ color: legendItem.iconColor }">stop</mat-icon>
        <span class="legend-with-tooltip">
          {{ legendItem.legendTranslationKey | translate }}
        </span>
      </div>
    </ng-container>
  </div>
</div>
